export default __webpack_public_path__ + "static/media/icon-badge.e6d5ce1d.svg";